<template>
    <div>
        <Breadcrumbs main="Settings" title="Settings" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Admin details</h5>
							</div><br>
							
							<form @submit.prevent="updateAdminDetails('admin')" enctype="multipart/form-data">
								<div class="row">
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Name</label>
											<input class="form-control" type="text" placeholder="Name" v-model="name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
											<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Username</label>
											<input class="form-control" type="text" placeholder="Username" v-model="user_name" v-bind:class="{ 'is-invalid': Boolean(errors.user_name) }"/>
											<div v-for="(val, index) in errors.user_name" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Email</label>
											<input class="form-control" type="text" placeholder="Email" v-model="email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>
											<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Phone</label>
											<input class="form-control" type="number" placeholder="Phone" v-model="phone" maxlength="10" @input="restrictMobileInput" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" minlength="10" maxLength="10"/>
											<div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
								<!-- </div>

								<div class="row"> -->
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Profile Image</label>
											<input class="form-control" type="file" accept="image/*" @change="handleImageChange" ref="fileInput"/>
											<div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4" v-if="(existingImage && existingImage !== '') || imagePreview">
										<div class="mb-3">
											<label class="control-label">Preview</label>
											<div class="image-preview-container" style="width: 100px; height: 100px; border: 1px solid #ddd; border-radius: 8px; overflow: hidden;">
												<img :src="imagePreview || (imageUrl + existingImage)" 
													 alt="Profile Preview" 
													 style="width: 100%; height: 100%; object-fit: cover;">
											</div>
										</div>
									</div>

									<div class="col-sm-2"></div>
									<div class="col-sm-2 float-end" style="margin-top: 35px;">
										<button type="submit" class="btn btn-primary float-end">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Change Password</h5>
							</div><br>
							
							<form @submit.prevent="updateAdminDetails('password')">
								<div class="row">
									<div class="col-sm-5">
										<div class="mb-3">
											<label class="control-label">Password</label>
											<input class="form-control" type="password" placeholder="Password" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"/>
											<div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-5">
										<div class="mb-3">
											<label class="control-label">Confirm Password</label>														
											<input class="form-control" type="Password" placeholder="Confirm Password" v-model="confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"/>
											<div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-2" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary float-end">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<div class="card" v-if="role_id == 1 || role_id == 8">
						<div class="card-body">
							<div class="row">
								<h5>Other Details</h5>
							</div><br>
							
							<form @submit.prevent="updateAdminDetails('special_incentive')">
								<div class="row">
									<div class="col-sm-5">
										<div class="mb-3">
											<label class="control-label">Special Incentive</label>
											<input class="form-control" type="text" placeholder="Special Incentive" v-model="spcl_incentive" v-bind:class="{ 'is-invalid': Boolean(errors.special_incentive) }"/>
											<div v-for="(val, index) in errors.special_incentive" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-7" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary float-end">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					
				</div>
			</div>
		</div>


		
	</div>
</template>

<script setup>
import { get, post } from '@/utils/api';
import { routes } from '@/constants/routes';
import Swal from '@/utils/swal';
import { onMounted, ref, inject } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const imageUrl = inject('imageUrl');
const name = ref('');
const user_name = ref('');
const email = ref('');
const phone = ref('');
let password = "";
let confirm_password = "";
const spcl_incentive = ref('');
const admin_image = ref(null);
const imagePreview = ref('');
const existingImage = ref('');
const errors = ref({});
const role_id = ref('');
const fileInput = ref(null);

const settings = () => {

	clearForm();

	get(routes.Settings, { }, false)
	.then((response) => {
		if (response.status === 200) {
			console.log(response.data.data);
			name.value = response.data.data.name;
            user_name.value = response.data.data.user_name;
            email.value = response.data.data.email;
            phone.value = response.data.data.mobile;
            spcl_incentive.value = response.data.data.special_incentive;
			role_id.value = response.data.data.role_id;
		} else {
			Swal.fire('', response.data.message || 'Error fetching data', 'error');
		}
	})
	.catch((error) => {
		if (error.response?.status === 422) {
			Swal.fire('', error.response.data.message || 'Validation error', 'error');
		} else if (error.response?.status === 500) {
			Swal.fire('', error.response.statusText || 'Server error', 'error');
		} else if (error.response?.status === 401) {
			Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
			router.push({ name: 'login' });
		} else {
			Swal.fire('', error.response.data?.message || 'Error occured', 'error');
		}
	});
};

const updateAdminDetails = (type) => {

	const formData = new FormData();
	let url = '';

	if(type == 'admin'){
		if(name.value && name.value !== 'null'){
			formData.append('name', name.value);
		}
		if(user_name.value && user_name.value !== 'null'){
			formData.append('user_name', user_name.value);
		}
		if(email.value && email.value !== 'null'){
			formData.append('email', email.value);
		}
		if(phone.value && phone.value !== 'null'){
			formData.append('mobile', phone.value);
		}
		if(admin_image.value){
			formData.append('image', admin_image.value);
		}
		url += routes.AdminProfile;
	} else if(type == 'password') {
		formData.append('password', password);
		formData.append('password_confirmation', confirm_password);
		url += routes.AdminPassword;
	} else {
		formData.append('special_incentive', spcl_incentive.value);
		url += routes.AdminSpecialIncentive;
	}
	

	post(url, formData, false)
	.then((response) => {
		if (response.status === 200) {
			Swal.fire('', response.data.message || 'Admin profile updated successfully', 'success').then(() => {
				window.location.reload();
			});
		} else {
			Swal.fire('', response.data.message || 'Error fetching data', 'error');
		}
	})
	.catch((error) => {
		if (error.response?.status === 422) {
			errors.value = error.response.data.message;
		} else if (error.response?.status === 500) {
			Swal.fire('', error.response.statusText || 'Server error', 'error');
		} else if (error.response?.status === 401) {
			Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
			router.push({ name: 'login' });
		} else {
			Swal.fire('', error.response.data?.message || 'Error occured', 'error');
		}
	});
};

const restrictMobileInput = (event) => {
	// Remove any non-digit characters and limit to 10 digits
	const value = event.target.value.replace(/\D/g, '').slice(0, 10);
	phone.value = value;
};

const handleImageChange = (event) => {
	const file = event.target.files[0];
	if (file) {
		admin_image.value = file;
		// Create preview URL
		const reader = new FileReader();
		reader.onload = (e) => {
			imagePreview.value = e.target.result;
		};
		reader.readAsDataURL(file);
	}
};

const clearForm = () => {
	errors.value = {},
	password = '',
	confirm_password = '',
	admin_image.value = null,
	imagePreview.value = ''
}

onMounted(() => {
	settings();
})


</script>